import { useLocation, useNavigate } from 'react-router-dom'
import { useCurrentUser } from '../CurrentUser'
import { alpha, Box, Button, CircularProgress, Link, Popover, Stack, styled, Typography } from '@mui/material'
import React, { useCallback, useState } from 'react';
import { ArrowDropDown, Logout } from '@mui/icons-material';
import CytrustedLogo from '../static/cytrusted-logo-small.png';

const HeaderContainer = styled('header')(({ theme }) => [
  {
    position: 'sticky',
    top: 0,
    transition: theme.transitions.create('top'),
    zIndex: theme.zIndex.appBar,
    backgroundColor: 'rgba(255,255,255,0.8)',
    backdropFilter: 'blur(8px)',
    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
  } as const,
  theme.applyStyles("dark", {
    backgroundColor: alpha(theme.palette.primary.dark, 0.7),
  }),
]);

export const Header = () => {
	const navigate = useNavigate()
	const [currentUser, logout] = useCurrentUser()
	const location = useLocation()

	const [isOpen, setIsOpen] = useState<boolean>(false)
	const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

	const navigateLogOut = useCallback(() => {
		logout(() => {
			window.location.reload();
		});
	}, [logout, navigate])

	return (
		<>
		<HeaderContainer>
			<Stack direction="row" alignItems={'center'}>
				<Link color="inherit" underline="none" onClick={() => navigate("/")}>
					<img src={CytrustedLogo} alt="cytrusted-logo" height={'48px'} style={{"margin":"0.5em"}}/>
				</Link>
				<Box flexGrow={1}></Box>
				{
					currentUser.loggedIn
					? <>
					<Box margin={'1em'}>
						<Button aria-describedby={'ActionButton'} variant="contained"
							sx={{textTransform: 'none'}}
							onClick={(e) => {
								setAnchorEl(e.currentTarget)
								setIsOpen(!isOpen)}
							}
							endIcon={<ArrowDropDown/>}
							>
							<Typography>Hello {currentUser.currentUser?.name ?? <CircularProgress />}!</Typography>
						</Button>
						<Popover open={isOpen} onClose={() => setIsOpen(false)}
							anchorEl={anchorEl}
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'left',
							}}
							transformOrigin={{
								vertical: 'top',
								horizontal: 'left',
							}}
						>
							<Stack flex={1} gap="$3" alignItems='flex-start' sx={{width:`${anchorEl?.getBoundingClientRect().width}px`}}>
								<Button startIcon={<Logout />} onClick={navigateLogOut}>Log out</Button>
							</Stack>
						</Popover>
						</Box>
					</>
					: <Box margin={'1em'}>
						<Button variant="contained" onClick={() => navigate("/login")}>Log In</Button>
						<Button sx={{flex: ''}} variant="outlined" onClick={() => navigate("/register")}>Sign Up</Button>
					</Box>
				}
			</Stack>
		</HeaderContainer>
		</>
	)
}
